import { runtimeConfig } from "@/runtime-config";
import { FaroText, TranslateVar } from "@faro-lotv/flat-ui";
import { Link } from "@mui/material";
import type { JSX } from "react";
import { NewFeatureAlert } from "../../new-feature/new-feature-alert";

/** @returns A component to alert the user about the floor plan generation feature */
export function GenerateFloorPlanFeatureAlert(): JSX.Element {
  const { supportMail } = runtimeConfig.externalLinks;

  return (
    <NewFeatureAlert
      localStorageKey="newFeatureFloorPlanGeneration"
      title="Floor plan generation"
      isBeta
      details={
        <>
          <FaroText variant="bodyM">
            To try Floor plan generation contact your Account Manager, Customer
            Success Manager or email{" "}
            <TranslateVar name="supportMail">
              <Link href={`mailto:${supportMail}`}>{supportMail}</Link>
            </TranslateVar>{" "}
            to have trial tokens added to your account. Once the tokens are
            applied, follow the steps below:
          </FaroText>

          <FaroText variant="bodyM" sx={{ pl: 2 }}>
            <ol style={{ paddingLeft: 0 }}>
              <li>Select a point cloud</li>
              <li>Click the three-dots icon to open the context menu</li>
              <li>Choose "Generate floor plan"</li>
            </ol>
          </FaroText>
        </>
      }
    />
  );
}
